/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration = Object.assign({
     wishlists: 'plus'
  }, window.boostSDAppConfig.integration || {});
}

if (boostSDAppConfig?.filterSettings) {
 boostSDAppConfig.filterSettings.filterTreeMobileStyle = 'style3-fullwidth';
}


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([(componentRegistry) => {
 const AppendWishlistImage = {
   name: 'Product Wishlist - Place wishlist icon on product image',
   apply() {
     return {
       props(props) {
         props.isShowWishlist = true;
         return props;
       },
     };
   },
 };
 componentRegistry.useComponentPlugin('ProductImage', AppendWishlistImage);
}]);


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
     componentRegistry.useModulePlugin('CartAPI', {
        name: 'Custom onSucces add to cart',
        apply(builder) {
           builder.on('methodFulfilled', 'addToCart', async (payload) => {
              if (payload.result.ok) {
                 window.OpenCartDrawer();
              }
           });
        },
     });

  }
]);

/* Boost 216372 */

const customize = {
 crossOOSProductSwatches: (componentRegistry) => {
   componentRegistry.useComponentPlugin("ProductSwatch", {
     name: "Cross out OOS swatches",
     enabled: true,
     apply: () => ({
       afterRender(element) {
         try {
           const swatchOptions = element?.getParams()?.props?.options;
           const productData =
         componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product
         || componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;
           if (swatchOptions?.length && productData) {
             const productVariants = productData.variants || [];
             swatchOptions.forEach((option) => {
               const optionValue = option.value;
               let optionAvailable = checkOptionStatus(
                 productVariants,
                 optionValue
               );
               if (optionAvailable == false) {
                 const swatchOption = document.querySelector(
                   `label[for*="${option.id}"]`
                 );

                 if (
                   swatchOption &&
                   swatchOption.closest(".boost-sd__product-swatch-option")
                 ) {
                   swatchOption.closest(".boost-sd__product-swatch-option").querySelector('label').classList.add('sold-out');
                 }
               }
             });
           }
         } catch (error) {
           console.log(error);
         }
       },
     }),
   });
 },
};
function checkOptionStatus(variants, optionValue) {
 for (let i = 0; i < variants.length; i++) {
   const variant = variants[i];
   // return variant.available;
   const variantOptions = variant.title?.split(" / ") || [];
   if (
     variantOptions.some(
       (option) =>
         option.toLowerCase() === optionValue.toLowerCase() &&
         variant.available
     )
   ) {
     return true;
   }
 }
 return false;
}

/* Ends Boost 211334 */
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
 customize.crossOOSProductSwatches,
]);


/* Boost 216372 */
